// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Sidescroll_wrapper__4fcZk","header":"Sidescroll_header__IsS54","scrollWrapper":"Sidescroll_scrollWrapper__lJRwD","desktopHidden":"Sidescroll_desktopHidden__9ClW4"};